module.exports = __webpack_public_path__ + "img/video-player/up@3x-a693395a37b90cb6b0441285f8f92584.png";